import axios from 'axios';

const API_URL = 'https://api.riselio.com';

const ENDPOINT_CITY = '/users/supplier/cities?province_id=';
const ENDPOINT_PROVINCE = '/users/supplier/provinces';
const ENDPOINT_WAY_SELLS = '/users/supplier/ways';
const ENDPOINT_PRICE_VARIANTS = '/users/supplier/prices';
const ENDPOINT_CATEGORY = '/listings/category';
const ENDPOINT_SUPPLIER = '/users/supplier/';

const API = axios.create({
    baseURL: API_URL,
    responseType: 'json'
});

export const getProvinces = async () => {
    return API.get(API_URL + ENDPOINT_PROVINCE).then((response) => {
        return response.data.payload;
    });
}

export const getCities = async (provinceId) => {
    return API.get(`${API_URL+ENDPOINT_CITY}${provinceId}`).then((response) => {
        return response.data.payload;
    });
}

export const getWaySells = async () => {
    return API.get(API_URL + ENDPOINT_WAY_SELLS).then((response) => {
        return response.data.payload;
    });
}

export const getPriceVariants = async () => {
    return API.get(API_URL + ENDPOINT_PRICE_VARIANTS).then((response) => {
        return response.data.payload;
    });
}

export const getCategories = async () => {
    return API.get(API_URL + ENDPOINT_CATEGORY).then((response) => {
        return response.data.payload;
    });
}

export const postSupplier = async ({name, email, whatsapp_number, website, facebook, 
    tokopedia, instagram, shopee, is_dropship, is_catalog, description, price_variants, 
    supplier_type, way_sells, city, category}) => {
    return API.post(API_URL + ENDPOINT_SUPPLIER, {name, email, whatsapp_number, website, facebook, 
        tokopedia, instagram, shopee, is_dropship, is_catalog, description, price_variants, 
        supplier_type, way_sells, city, category}).then((response) => {
        return response.data;
    });

}

export default API;